module.exports = __webpack_public_path__ + "img/tonari@2x.888e9f1f.png";